function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#18ea95;}.b{fill:#18efa4;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0)"
}, React.createElement("path", {
  className: "a",
  d: "M-1710.946,410.846l-.26-.2,15.974-20.677,13.058,12.943,18.127-12.7,14.434-.155,11.617-15.8.264.194-11.714,15.931-14.5.156-18.268,12.8-12.99-12.875Z",
  transform: "translate(1711.206 -374.253)"
}), React.createElement("g", {
  transform: "translate(15.078 15.049)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})), React.createElement("g", {
  transform: "translate(28.212 27.837)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})), React.createElement("g", {
  transform: "translate(46.409 15.083)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})), React.createElement("g", {
  transform: "translate(60.753 15.083)"
}, React.createElement("rect", {
  className: "b",
  width: 1.826,
  height: 1.826
})));

var SvgMarketAnalysis = function SvgMarketAnalysis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 73.474,
    height: 36.593,
    viewBox: "0 0 73.474 36.593",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarketAnalysis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Market_Analysis.a576877b.svg";
export { ForwardRef as ReactComponent };